import { AssigneesComponent } from "projects/reg-hub-client/src/app/orders/assignees/assignees.component";
import { AssignmentDetailsComponent } from "projects/reg-hub-client/src/app/orders/assignment-details/assignment-details.component";
import { AssignorsComponent } from "projects/reg-hub-client/src/app/orders/assignors/assignors.component";
import { CollateralComponent } from "projects/reg-hub-client/src/app/orders/collateral/collateral.component";
import { DebtorsComponent } from "projects/reg-hub-client/src/app/orders/debtors/debtors.component";
import { ReviewComponent } from "projects/reg-hub-client/src/app/orders/review/review.component";
import { Step, StepValidationState } from "projects/reg-hub-client/src/interfaces/step";
import { Stepper } from "projects/reg-hub-client/src/interfaces/stepper";

export class QCRG14AssignmentStepper implements Stepper {

    steps: Step[];

    constructor() {
        this.steps = [
            { title: "Details", content: AssignmentDetailsComponent, validationState: StepValidationState.DefaultState },
            { title: "Debtors", content: DebtorsComponent, validationState: StepValidationState.DefaultState },
            { title: "Assignors", content: AssignorsComponent, validationState: StepValidationState.DefaultState },
            { title: "Assignees", content: AssigneesComponent, validationState: StepValidationState.DefaultState },
            { title: "Collateral", content: CollateralComponent, validationState: StepValidationState.DefaultState },
            { title: "Review", content: ReviewComponent, validationState: StepValidationState.DefaultState }
        ]
    }
}